'use client';

import { useEffect } from 'react';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

/** Jira Service Management portal — requires an ABRI Support customer login. */
const SUPPORT_PORTAL_URL =
  'https://abri-support.atlassian.net/servicedesk/customer/portal/43';

export default function RedirectSupport() {
  useDocumentTitle('Support Portal');

  useEffect(() => {
    window.location.replace(SUPPORT_PORTAL_URL);
  }, []);

  return null;
}
